import { h as __h } from "preact";
import { Component, h } from "preact";
import { CDN } from "~/lib/consts.js";
import html from "~/util/html.js";
import { modal } from "~/util/modal.js";
import { PromiseSignal } from "~/util/promise.js";
import request from "~/util/request.js";
import { is, object, string } from "~/util/validate.js";
import Button from "~/component/Button.js";
import Icon from "~/component/Icon.js";
import adminStyle from "~/admin/lib/style.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./downloadRelay.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./downloadRelay.module.css", import.meta.url);
const css = adopt(sheet);
export const downloadRelay = async () => {
  await modal({
    title: "Download binary",
    content: resolve => h(ModalChildren, {
      resolve
    })
  });
};

/**
 * @extends {Component<Props>}
 *
 * @typedef {object} Props
 * @property {() => void} resolve
 */
class ModalChildren extends Component {
  #version = new PromiseSignal(async () => {
    const res = await request("GET", `${CDN}/relay/latest/version.json`, {
      cache: "no-store"
    });
    if (!is(object({
      name: string
    }), res)) throw new Error(`version.json missing "name"`);
    return res.name;
  });

  /** @override */
  componentDidMount() {
    this.#version.invoke().catch(() => {});
  }
  render() {
    const base = `${CDN}/relay/latest`;
    const version = this.#version.data ?? "";
    const suffix = version ? ` ${version}` : "";
    return __h("div", {
      "class": adminStyle.modal
    }, __h("div", {}, __h("p", {}, "Download the latest Phaze Relay binary for your server below:"), __h("div", {
      "class": css.downloads
    }, __h("a", {
      "class": css.download,
      href: base + "/phaze-relay-linux-amd64.zip",
      download: true
    }, __h(Icon, {
      name: "download-binary",
      size: 20
    }), "Phaze Relay", suffix, " - Linux (x86_64)"), __h("a", {
      "class": css.download,
      href: base + "/phaze-relay-linux-arm64.zip",
      download: true
    }, __h(Icon, {
      name: "download-binary",
      size: 20
    }), "Phaze Relay", suffix, " - Linux (ARM64)")), __h("p", {}, "Unzip the archive and follow the included 'readme.txt'."), __h("p", {}, __h("a", {
      href: base + "/SHA256SUMS",
      download: true
    }, "See checksums"))), __h("div", {
      "class": adminStyle.actions
    }, __h(Button, {
      onClick: () => this.props.resolve()
    }, "Close")));
  }
}